import { JetSportBox } from "../../components/BoxView/JetSportBox";
import { SecondaryButton } from "../../components/Buttons/SecondaryButton";
import { PrimaryButton } from "../../components/Buttons/PrimaryButton";
import { BoxHeader2 } from "../../components/BoxView/BoxHeader2";
import { BoxContent } from "../../components/BoxView/BoxContent";
import { BoxFooter } from "../../components/BoxView/BoxFooter";
import { OrderLineList } from "./subcomponents/OrderLineList";
import { PriceTotal } from "./subcomponents/PriceTotal";
import { Order, OrderLine } from "../../../core/models/entities/Order";
import {
  OrderDeliveryForm,
  DeliveryTypeOption,
  PackagingOption,
} from "../order-confirmation/useOrderConfirmationEditViewModel";
import { useProfileContext } from "../../../contexts/ProfileContext";
import { Role } from "../../../core/models/entities/Role";
import { Switch } from "../../components/ui/Switch";
import { useWorkshopMode } from "../../../hooks/useWorkshopMode";

export interface OrderDetailsComponentViewModel {
  orderNo: string;
  orderlines: OrderLine[];
  handleBack: () => void;
  handleConfirm: () => void;
  form: OrderDeliveryForm;
  deliveryTypeGroupList: DeliveryTypeOption[];
  packagingGroupList: PackagingOption[];
  handleOrderFormUpdate: (form: OrderDeliveryForm) => void;
  subTotal?: number;
  vat?: number;
  totalAmount?: number;
  readonly?: boolean;
  order: Order;
  onBack: () => void;
  onReorder: () => void;
  showCustomerPrices: boolean;
  setShowCustomerPrices: (value: boolean) => void;
}

export function OrderDetailsComponent({
  order,
  orderlines,
  subTotal,
  vat,
  totalAmount,
  onBack,
  onReorder,
  readonly,
  showCustomerPrices,
  setShowCustomerPrices,
}: OrderDetailsComponentViewModel) {
  const { role, organizationId } = useProfileContext();
  // Workshop mode: order stays fully usable as a work instruction, but every
  // price surface (columns, totals, price switches) is removed.
  const workshopMode = useWorkshopMode();
  return (
    <JetSportBox>
      <BoxHeader2
        className={"uppercase text-sm flex justify-between items-center"}
      >
        <p>
          <span className={"font-bold"}>Order </span>#{order.orderNumber}
        </p>
        {role === Role.Vendor &&
          !workshopMode &&
          readonly &&
          order.organization.id !== organizationId && (
            <div className="flex items-center gap-2">
              <label>Show customer prices</label>
              <Switch
                checked={showCustomerPrices}
                onCheckedChange={setShowCustomerPrices}
              />
            </div>
          )}
      </BoxHeader2>
      <BoxContent>
        <div className={"flex-1 flex-col my-10"}>
          <OrderLineList
            hideColumns={
              workshopMode
                ? { unitPrice: true, price: true, subTotal: true }
                : undefined
            }
            orderlines={orderlines}
            currency={order.currency}
            showCustomerPrices={showCustomerPrices}
            readonly={readonly}
          />
          {!workshopMode && (
            <PriceTotal
              subTotal={subTotal || 0}
              vat={vat || 0}
              totalAmount={totalAmount || 0}
              currency={order.currency}
            />
          )}
        </div>
      </BoxContent>
      <BoxFooter className={"justify-between"}>
        <SecondaryButton onClick={onBack}>Back</SecondaryButton>
        {role !== Role.Admin && (
          <PrimaryButton onClick={onReorder}>Reorder</PrimaryButton>
        )}
      </BoxFooter>
    </JetSportBox>
  );
}
